// Mega Menu Ebikes - Optimized
(function() {
  'use strict';

  // 安全地获取元素
  function safeClosest(element, selector) {
    if (!element || typeof element.closest !== 'function') return null;
    try {
      return element.closest(selector);
    } catch (e) {
      return null;
    }
  }

  // 使用事件委托处理所有 tab 切换
  function handleTabSwitch(trigger) {
    if (!trigger) return;
    
    const menu = safeClosest(trigger, '.mega-menu-ebikes');
    if (!menu) return;
    
    const targetId = trigger.dataset.tabTarget;
    if (!targetId) return;
    
    const triggers = menu.querySelectorAll('.aligned-links-left__title');
    const contents = menu.querySelectorAll('.bike-nav-tab_wrap');
    
    // 更新 trigger 状态
    triggers.forEach(t => t.classList.remove('active'));
    trigger.classList.add('active');
    
    // 更新 content 状态
    contents.forEach(content => {
      if (content.id === targetId) {
        content.classList.add('active');
      } else {
        content.classList.remove('active');
      }
    });
  }

  // 获取有效的 trigger
  function getTrigger(element) {
    return safeClosest(element, '.aligned-links-left__title');
  }

  // 事件处理器
  function onTabEvent(e) {
    const target = e.target;
    if (!target) return;
    
    // 如果 target 是文本节点，获取其父元素
    const element = target.nodeType === Node.TEXT_NODE ? target.parentElement : target;
    if (!element) return;
    
    const trigger = getTrigger(element);
    if (trigger) {
      handleTabSwitch(trigger);
    }
  }

  // 鼠标悬停处理（桌面端）
  document.addEventListener('mouseenter', onTabEvent, true);

  // 点击处理（移动端兼容）
  document.addEventListener('click', onTabEvent);

  // 初始化：默认激活第一个 tab
  function initFirstTab() {
    const menus = document.querySelectorAll('.mega-menu-ebikes');
    menus.forEach(menu => {
      const activeTrigger = menu.querySelector('.aligned-links-left__title.active');
      if (!activeTrigger) {
        const firstTrigger = menu.querySelector('.aligned-links-left__title');
        if (firstTrigger) {
          firstTrigger.classList.add('active');
          const targetId = firstTrigger.dataset.tabTarget;
          if (targetId) {
            const content = menu.querySelector(`#${targetId}`);
            if (content) {
              content.classList.add('active');
            }
          }
        }
      }
    });
  }

  // 页面加载完成后初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFirstTab);
  } else {
    initFirstTab();
  }

})();